import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import * as Styled from "./box-edit-buttons.style";
import { CanvasOverlay } from "./canvas-overlay";
import { EditButtons, } from "ui/components/elements/edit-buttons/edit-buttons";
/**
 * Floating edit controls over a selected cardboard box. Reuses the shared
 * EditButtons (duplicate / rotate / delete) so it matches the node selection
 * overlays, anchored at the box centre in screen space.
 */
export var BoxEditButtons = function (_a) {
    var centerX = _a.centerX, centerY = _a.centerY, actions = _a.actions, containerRef = _a.containerRef;
    return (_jsx(CanvasOverlay, { x: centerX, y: centerY, children: _jsx(Styled.BoxEditButtons, { ref: containerRef, children: _jsx(EditButtons, { hasBackground: true, actions: actions }) }) }));
};
